import { render, staticRenderFns } from "./carouselList.vue?vue&type=template&id=262966f2&scoped=true&"
import script from "./carouselList.vue?vue&type=script&lang=js&"
export * from "./carouselList.vue?vue&type=script&lang=js&"
import style0 from "./carouselList.vue?vue&type=style&index=0&id=262966f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262966f2",
  null
  
)

export default component.exports